import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import routers from './router'
import axios from 'axios'

import app_config from "./config.json";
import {
  stat
} from 'fs'
axios.defaults.baseURL = app_config.api_server;


Vue.config.productionTip = false
Vue.use(VueRouter)





function scrollBehavior() {
  return {
    x: 0,
    y: 0
  }
}

const router = new VueRouter({
  mode: 'hash',
  routes: routers,
  scrollBehavior
})



Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    debug: false,
    loggined: false,
    played_recently: [],
    categories: ["Action", "Comedy", "Animation", "Drama", "Fantasy", "Romance", "Horror", "Sci-fi", "Others"],
    cdt: {
      action: "Action",
      comedy: "Comedy",
      animation: "Animation",
      drama: "Drama",
      fantasy: "Fantasy",
      romance: "Romance",
      horror: "Horror",
      scifi: "Sci-fi",
      others: "Others",


    }
  },
  mutations: {

    update_categories(state, list) {
      state.categories = list
    },
    pushPlayed_recently(state, v_just_viewed) {
      let viewed = false;
      for (let i = 0; i < state.played_recently.length; i++) {
        if (v_just_viewed.id === state.played_recently[i].id) {
          viewed = true;
          console.log('repeated view')
        }

      }
      if (viewed === false) {
        state.played_recently.unshift(v_just_viewed)
        if (state.played_recently.length > 5) {
          state.played_recently.pop();
        }
      }


      window.localStorage.setItem('noovo_played_recently', JSON.stringify(state.played_recently));
    },
    initPlayed_recently(state, vlist) {
      state.played_recently = vlist
    }
  },
  getters: {
    locateLive: (state) => (channel_name) => {
      let index = state.live_list.findIndex(v => v.channel_name == channel_name);
      // console.log('calling me:' + channel_name)
      // console.log('calling me:' + state.live_list)
      return state.live_list[index];
    }

  }
})




new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')